export function normalizeHtml(value: string | null | undefined): string | null {
  if (!value) return null;

  const normalized = value.replaceAll('&nbsp;', ' ').trim();
  const textOnly = stripHtmlTags(normalized).trim();

  return textOnly.length > 0 ? normalized : null;
}

function stripHtmlTags(value: string): string {
  let result = '';
  let insideTag = false;

  for (const character of value) {
    if (character === '<') {
      insideTag = true;
    } else if (character === '>') {
      insideTag = false;
    } else if (!insideTag) {
      result += character;
    }
  }

  return result;
}
